
<div *ngIf="showErrors" class="alert valign-children-middle" id="error-main-container">
    <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
    </div>
    <div>
        <h2>Error</h2>
        <p>Something went wrong. Please try again.</p>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div>
</div>
<!-- <div> -->
    <br>
    <div class="review-section">
        <h2 class="review-heading" style="margin-bottom: 0px !important;">Review devices grouping details</h2>
        <br>
        <div class="review-info">
            <div class="first-block review-blocks">
                <p style="width:max-content">Confirm your device(s) and grouping selections.</p>
            </div>                        
       </div>
        <br>
    </div>
    <br>
    <hr>
    <div class="review-section">
        <br>
        <h2 class="review-heading" style="margin-bottom: 0px !important;">Devices</h2>
        <div class="review-info">
                <p class="review-block-heading">You've selected {{totalDevices}} device(s) to move into a group.</p>
                <a href="javascript:void(0)" (click)="clickChange()">
                    <strong>Change</strong>
                  </a>
        </div>
        <div id="viewDevices" *ngIf="!showTable">
            <a href="javascript:void(0)" (click)="clickShowTable()"><strong>View all devices</strong></a>  
        </div>
        
    </div>
    
    <div *ngIf="showTable">
        <app-custom-grid-extended [gridOptions]='gridOptions' (gridEvent)="gridEventChanges($event)"
        (onDataChange)="onRowClick($event)"></app-custom-grid-extended>
       <a  href="javascript:void(0)" (click)="clickHideTable()"><strong>Hide devices</strong></a>
    </div>
  
    <br>
    <hr>
    <div class="review-section">
        <br>
        <h2 class="review-heading" style="margin-bottom: 0px !important;">Group</h2>
        <br>
        <div class="review-info" style=" margin-bottom: 36px;">
                <p class="review-block-heading">Device(s) will be moved to : <strong>{{groupName}}</strong></p>
                <a href="javascript:void(0)" (click)="clickBack()">
                    <strong>Change</strong>
                  </a>
       </div>
        <br>
        <hr>
    </div>
  

    <div id="button-section" class="row live">
        <div class="col-sm-12 col-md-12 text-right">
          <button class="btn btn-secondary pull-right continue-btn btn-width"
           (click)="submitGroup()">Continue</button>
          <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel btn-width" (click)="clickBack()">Back</a>
          <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel btn-width"
            (click)="clickCancel()">Cancel</a>
        </div>
      </div>



